<template>
  <div :class="$style.container">
    <div :class="$style.head" @click="onClickHead">
      {{ template.name }}
      <div :class="$style.toggle">
        <feather-icon icon="ChevronDownIcon" :class="$style.toggleIconContainer" :svg-classes="$style.toggleIcon" />
      </div>
    </div>
    <div v-if="active" :class="$style.body">
      <h5 class="mb-6">{{ isForLegalEntity ? legalEntity ? legalEntity.name : '' : selectedBuilding.address }}</h5>
      <div :class="$style.row">
        <div :class="$style.upload">
          <h6 class="mb-6">Загрузка файла</h6>
          <elsa-v-upload v-model="file" />

          <component v-if="templateGroup.form" v-bind:is="templateGroup.form" :data="formData"></component>

          <vs-checkbox
            v-if="templateGroup.canSaveWithoutSucceedData"
            :class="$style.saveCheckbox"
            v-model="saveWithoutSucceedData"
          >
            Сохранять при отсутствии распознанных платежей
          </vs-checkbox>
          <div :class="$style.uploadButton">
            <app-button color="success" type="border" @click="onUploadFile">Загрузить</app-button>
          </div>
          <div v-if="template.example" class="mt-2 text-center">
            <a :href="template.example" target="_blank">Скачать пример файла</a>
          </div>
        </div>
        <div :class="$style.history">
          <h6 class="mb-6">История импорта</h6>
          <vs-table
            v-if="history"
            :data="history"
            max-items="5"
            pagination class="w-full"
            noDataText="История импорта пуста"
          >
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th>Файл</vs-th>
              <vs-th>Дата</vs-th>
              <vs-th />
            </template>

            <template slot-scope="{data}" ref="content">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <feather-icon
                    v-if="tr.is_save === null"
                    icon="ClockIcon"
                    svg-classes="text-grey"
                    title="В процессе"
                  />
                  <feather-icon
                    v-else-if="tr.is_save"
                    icon="CheckCircleIcon"
                    svg-classes="text-success"
                    title="Загружен"
                  />
                  <feather-icon v-else icon="AlertTriangleIcon" svg-classes="text-danger" title="Не загружен" />
                </vs-td>
                <vs-td :class="$style.linkWrapper">
                  <a
                    :class="$style.link"
                    :href="tr.file.path | imgPath"
                    :download="tr.name"
                    target="_blank"
                    :title="tr.file.name"
                  >
                    <feather-icon icon="DownloadIcon" :class="$style.linkIcon" />
                    <span>{{ tr.file.name }}</span>
                  </a>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                  {{ tr.created_at | moment('DD.MM.YYYY HH:mm:ss') }}
                </vs-td>
                <vs-td>
                  <a href="#" @click.prevent="onOpenResult(tr)">подробнее</a>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:   "ImportTab",
  props:  ['template', 'templateGroup', 'buildingId'],
  mixins: [notifyHttpError],
  data() {
    return {
      active:                 false,
      file:                   null,
      saveWithoutSucceedData: false,
      history:                null,
      legalEntity:            null,
      formData:               {},
    };
  },
  computed: {
    selectedBuilding() {
      return this.$store.getters['appUser/selectedHouse'];
    },
    isForLegalEntity() {
      return this.templateGroup.parent === 'legalEntity';
    },
  },
  methods:  {
    onClickHead() {
      this.active = !this.active;
      if (this.active && !this.history) {
        this.loadHistory();
        this.loadLegalEntity();
      }
    },

    onUploadFile() {
      if (!this.file) return;

      const body = new FormData();
      body.append('file', this.file);
      body.append('buildings_id', this.buildingId);
      body.append('save_without_succeed_data', this.saveWithoutSucceedData);
      for(let key in this.formData) body.append(key, this.formData[key]);
      this.$vs.loading({ type: 'default' });
      this.$http.post(`import/${this.template.id}`, body)
        .catch(this.notifyHttpError)
        .finally(() => {
          this.file = null;
          this.$vs.loading.close();
          this.loadHistory();
        });
    },

    onOpenResult( historyItem ) {
      this.$modal.open({
        size:           'md',
        title:          'Результат импорта',
        component:      () => import('@/components/calculated-program/import/ImportResult'),
        componentProps: { historyItem, templateGroup: this.templateGroup },
      });
    },

    loadLegalEntity() {
      this.$http.get(`/legal/entity/${this.selectedBuilding.legal_entities_id}`).then(( { data } ) => {
        this.legalEntity = data;
      });
    },

    loadHistory() {
      const params = { buildings_id: this.buildingId };
      if (this.isForLegalEntity) params.le_id = this.selectedBuilding.legal_entities_id;
      this.$http.get(`import/${this.template.id}/history`, { params })
        .then(( { data } ) => this.history = data);
    },
  },
  watch:    {
    template() {
      this.history = null;
      this.legalEntity = null;
      if (this.active) {
        this.loadHistory();
        this.loadLegalEntity();
      }
    },
  },
};
</script>

<style module lang="scss">
.container {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-left: 0;
  border-radius: 0 7px 7px 0;
  margin-bottom: -1px;

  &:last-of-type {
    margin-bottom: 0;
  }
}

.head {
  padding: 11px 22px;
  position: relative;
  cursor: pointer;
  font-size: 14px;
}

.toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.toggleIconContainer {
  display: block;
}

.toggleIcon {
  display: block;
  width: 18px;
  height: 18px;
}

.body {
  //height: 350px;
  padding: 11px 22px;
}

.row {
  display: flex;
}

.upload {
  width: 200px;
  margin-right: 30px;
  flex-shrink: 0;
}

.uploadButton {
  text-align: center;
  margin-top: 1em;
}

.history {
  flex: 1;
  min-width: 0;
}

.linkWrapper {
  position: relative;
  width: 100%;
}

.link {
  position: absolute;
  padding: 0 10px;
  left: 0;
  display: flex;
  align-items: center;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);

  span {
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.linkIcon {
  flex-shrink: 0;
  margin-right: 4px;
}

.saveCheckbox {
  font-size: .8em;
  margin-top: 5px;
}

</style>
